import { ROUTES } from 'services/utils/enums';
import { sendRequest } from 'services/api';

export const getSendbirdAuth = async function(userId = null) {
    if (!userId) {
        return sendRequest(ROUTES.GET_SENDBIRD_AUTH);
    } else {
        return sendRequest(ROUTES.GET_SENDBIRD_AUTH, `/${userId}`);
    }
};

export default {
    getSendbirdAuth,
};
